import React, { Component } from 'react';
import { StyleSheet, Text, View, Dimensions, TouchableHighlight } from 'react-native';
import { QSendNotification } from 'qunar-react-native';
import SizeUtil from '../../../utils/SizeUtil';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

const { height } = Dimensions.get('window');

const ROW_HEIGHT = 45;
const separatorHeight = 1;
const HEADREHEIGHT = 24;
const scrollBarItemHeight = SizeUtil.getSize(16);

class CityItem extends Component<{ info: { item: { prenum: number; zh: string } } }> {
    public itemOnPress = (prenum: number, zh: string) => {
        QSendNotification.sendNotification({
            name: 'cmnOrderRn-selectCountry-change',
            data: {
                prenum,
                zh
            }
        });
        Ext.back();
    };

    public render() {
        const { info } = this.props;
        if (!info) return <View />;
        return (
            <TouchableHighlight
                style={{ width: '100%', height: ROW_HEIGHT, justifyContent: 'center' }}
                onPress={() => {
                    this.itemOnPress(info.item.prenum, info.item.zh);
                }}
                underlayColor="#F6F6F6"
            >
                <View style={styles.rowStyle}>
                    <Text style={styles.rowTextStyle}>{info.item.zh}</Text>
                    <Text style={styles.rowTextStyle}>{`+${info.item.prenum}`}</Text>
                </View>
            </TouchableHighlight>
        );
    }
}

const styles = StyleSheet.create({
    sectionStyle: {
        color: baseColor.text3,
        lineHeight: HEADREHEIGHT,
        paddingLeft: SizeUtil.getSize(19.5)
    },
    rowStyle: {
        marginLeft: SizeUtil.getSize(20),
        marginRight: SizeUtil.getSize(20),
        flexDirection: 'row',
        justifyContent: 'space-between'
    },

    rowTextStyle: {
        fontSize: 15,
        color: baseColor.text1
    },
    separtorStyle: {
        height: separatorHeight,
        backgroundColor: baseColor.background2,
        marginHorizontal: SizeUtil.getSize(20)
    },
    noDataViewStyle: {
        backgroundColor: 'red',
        flex: 1,
        height
    },
    noDataSubViewStyle: {
        alignItems: 'center',
        textAlign: 'center',
        lineHeight: height,
        color: 'white'
    },
    sectionItemViewStyle: {
        position: 'absolute',
        width: scrollBarItemHeight,
        top: 0
    },
    sectionItemStyle: {
        fontSize: 12,
        textAlign: 'center',
        alignItems: 'center'
    }
});

export default CityItem;
